import { render } from "./PaneTitle.vue?vue&type=template&id=010d0499&scoped=true&ts=true"
import script from "./PaneTitle.vue?vue&type=script&lang=ts"
export * from "./PaneTitle.vue?vue&type=script&lang=ts"

import "./PaneTitle.vue?vue&type=style&index=0&id=010d0499&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010d0499"]])

export default __exports__